if (!customElements.get('waypoint-list')) {
  customElements.define('waypoint-list',
    class WaypointList extends HTMLElement {

      // ─── Configuration ────────────────────────────────────────────────
      static MAX_STOPS = 3;
      // ──────────────────────────────────────────────────────────────────

      elements = {
        addButton: this.querySelector('.add-waypoint-button'),
        // Function so each call returns a live NodeList (not a cached snapshot)
        stops: () => this.querySelectorAll('waypoint-stop:not([fixed])'),
      };

      events = {
        handleClick: (e) => {
          if (e.target.closest('.add-waypoint-button') === this.elements.addButton) {
            this._addStop();
          }
        },
        handleWaypointRemove: (e) => {
          e.target.remove();
          this._reindex();
          this._syncButton();
        },
      };

      connectedCallback() {
        this.bindEvents();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.events.handleClick);
        this.removeEventListener('waypoint:remove', this.events.handleWaypointRemove);
      }

      bindEvents() {
        this.addEventListener('click', this.events.handleClick);
        this.addEventListener('waypoint:remove', this.events.handleWaypointRemove);
      }

      _addStop() {
        const stop = document.createElement('waypoint-stop');
        // +2: pick-up is implicitly Stop 1, dynamic stops start at 2
        stop.dataset.index = this.elements.stops().length + 2;
        this.insertBefore(stop, this.elements.addButton);
        this._syncButton();
      }

      _reindex() {
        this.elements.stops().forEach((stop, i) => { stop.index = i + 2; });
      }

      _syncButton() {
        this.elements.addButton.hidden = this.elements.stops().length >= WaypointList.MAX_STOPS;
      }

    }
  );
}

